// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_secret.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
import { AppUserRef } from "./app_user";
/**
 * @generated from protobuf message c1.api.app.v1.AppSecretExpandMask
 */
export interface AppSecretExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppSecretRef
 */
export interface AppSecretRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 3;
     */
    appResourceTypeId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppSecretsWithAlertCountRequest
 */
export interface SearchAppSecretsWithAlertCountRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 5;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppSecretRef refs = 6;
     */
    refs: AppSecretRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef identity_app_user_refs = 7;
     */
    identityAppUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppSecretExpandMask expand_mask = 8;
     */
    expandMask?: AppSecretExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppSecretsWithAlertCountResponse
 */
export interface SearchAppSecretsWithAlertCountResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppSecretResourceView list = 1;
     */
    list: AppSecretResourceView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppSecretResourceView
 */
export interface AppSecretResourceView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppSecretResource app_secret = 1;
     */
    appSecret?: AppSecretResource;
    /**
     * @generated from protobuf field: int32 alert_count = 2;
     */
    alertCount: number;
    /**
     * @generated from protobuf field: string app_path = 3;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string resource_type_path = 4;
     */
    resourceTypePath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppSecretResource
 */
export interface AppSecretResource {
    /**
     * The app that this secret belongs to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The secret type that this secret is.
     *
     * @generated from protobuf field: string app_resource_type_id = 2;
     */
    appResourceTypeId: string;
    /**
     * The id of the secret.
     *
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret was discovered in ConductorOne.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret was last updated in ConductorOne.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret was deleted in ConductorOne.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * The display name for this secret.
     *
     * @generated from protobuf field: string display_name = 7;
     */
    displayName: string;
    /**
     * The ID of the user that is associated with the AppSecret.
     *
     * @generated from protobuf field: string identity_app_user_id = 8;
     */
    identityAppUserId: string;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret expires.
     *
     * @generated from protobuf field: google.protobuf.Timestamp secret_expires_at = 9;
     */
    secretExpiresAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret was last used or updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 10;
     */
    lastUsedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppSecret was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp secret_created_at = 11;
     */
    secretCreatedAt?: Timestamp;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppSecretExpandMask$Type extends MessageType<AppSecretExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppSecretExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "app_resource_type_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppSecretExpandMask
 */
export const AppSecretExpandMask = new AppSecretExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppSecretRef$Type extends MessageType<AppSecretRef> {
    constructor() {
        super("c1.api.app.v1.AppSecretRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppSecretRef
 */
export const AppSecretRef = new AppSecretRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppSecretsWithAlertCountRequest$Type extends MessageType<SearchAppSecretsWithAlertCountRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppSecretsWithAlertCountRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppSecretRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "identity_app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 8, name: "expand_mask", kind: "message", T: () => AppSecretExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppSecretsWithAlertCountRequest
 */
export const SearchAppSecretsWithAlertCountRequest = new SearchAppSecretsWithAlertCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppSecretsWithAlertCountResponse$Type extends MessageType<SearchAppSecretsWithAlertCountResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppSecretsWithAlertCountResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppSecretResourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppSecretsWithAlertCountResponse
 */
export const SearchAppSecretsWithAlertCountResponse = new SearchAppSecretsWithAlertCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppSecretResourceView$Type extends MessageType<AppSecretResourceView> {
    constructor() {
        super("c1.api.app.v1.AppSecretResourceView", [
            { no: 1, name: "app_secret", kind: "message", T: () => AppSecretResource },
            { no: 2, name: "alert_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppSecretResourceView
 */
export const AppSecretResourceView = new AppSecretResourceView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppSecretResource$Type extends MessageType<AppSecretResource> {
    constructor() {
        super("c1.api.app.v1.AppSecretResource", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 8, name: "identity_app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "secret_expires_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "last_used_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "secret_created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppSecretResource
 */
export const AppSecretResource = new AppSecretResource$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppSecretSearch
 */
export const AppSecretSearch = new ServiceType("c1.api.app.v1.AppSecretSearch", [
    { name: "SearchAppSecretsWithAlertCount", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppSecretsWithAlertCountRequest, O: SearchAppSecretsWithAlertCountResponse }
]);
